/**
 * Password-reset emails must contain a reachable URL that also passes
 * backend @IsUrl() validation (localhost is rejected by default).
 */
export const getPasswordResetCallbackUrl = (): string => {
  const origin = window.location.origin;
  const isLocalHost =
    /^(https?:\/\/)?(localhost|127\.0\.0\.1)(:\d+)?$/i.test(origin) ||
    origin.includes('localhost') ||
    origin.includes('127.0.0.1');

  const configuredProduction = process.env.REACT_APP_PRODUCTION_BASE_URL;
  const productionBase =
    configuredProduction && configuredProduction !== 'auto'
      ? configuredProduction
      : 'https://app.anonify.nl';

  const base = (isLocalHost ? productionBase : origin).replace(/\/$/, '');
  return `${base}/forgotPassword/`;
};
